import { defineMessages } from "react-intl";

import {
	validator,
	vasoreactivityTestMessages
} from "lib/build/forms/htx/current-cardiological-state/rightHeartCatheterization";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	rightHeartCatheterization: {
		id: "form.right_heart_catheterization",
		defaultMessage: "Jobbszívfél-katéterezés"
	},
	vasoreactivityTest: {
		id: "form.right_heart_catheterization.vasoreactivity_test",
		defaultMessage: "Vazoreaktivitási teszt (VRT) történt-e"
	},
	rrsValue: {
		id: "form.right_heart_catheterization.rrs",
		defaultMessage: "RRs"
	},
	rrsPostVrt: {
		id: "form.right_heart_catheterization.rrs.post_vrt",
		defaultMessage: "RRs - postVRT"
	},
	hrValue: {
		id: "form.right_heart_catheterization.hr",
		defaultMessage: "HR"
	},
	hrPostVrt: {
		id: "form.right_heart_catheterization.hr.post_vrt",
		defaultMessage: "HR - postVRT"
	},
	cvpValue: {
		id: "form.right_heart_catheterization.cvp",
		defaultMessage: "CVP (Rap)"
	},
	cvpPostVrt: {
		id: "form.right_heart_catheterization.cvp.post_vrt",
		defaultMessage: "CVP (Rap) - postVRT"
	},
	svO2Value: {
		id: "form.right_heart_catheterization.sv_o2",
		defaultMessage: "SvO2"
	},
	svO2PostVrt: {
		id: "form.right_heart_catheterization.sv_o2.post_vrt",
		defaultMessage: "SvO2 - postVRT"
	},
	rvpsValue: {
		id: "form.right_heart_catheterization.rvps",
		defaultMessage: "RVPs"
	},
	rvpsPostVrt: {
		id: "form.right_heart_catheterization.rvps.post_vrt",
		defaultMessage: "RVPs - postVRT"
	},
	rvpdValue: {
		id: "form.right_heart_catheterization.rvpd",
		defaultMessage: "RVPd"
	},
	rvpdPostVrt: {
		id: "form.right_heart_catheterization.rvpd.post_vrt",
		defaultMessage: "RVPd - postVRT"
	},
	rvpmValue: {
		id: "form.right_heart_catheterization.rvpm",
		defaultMessage: "RVPm"
	},
	rvpmPostVrt: {
		id: "form.right_heart_catheterization.rvpm.post_vrt",
		defaultMessage: "RVPm - postVRT"
	},
	papsValue: {
		id: "form.right_heart_catheterization.paps",
		defaultMessage: "PAPs"
	},
	papsPostVrt: {
		id: "form.right_heart_catheterization.paps.post_vrt",
		defaultMessage: "PAPs - postVRT"
	},
	papdValue: {
		id: "form.right_heart_catheterization.papd",
		defaultMessage: "PAPd"
	},
	papdPostVrt: {
		id: "form.right_heart_catheterization.papd.post_vrt",
		defaultMessage: "PAPd - postVRT"
	},
	mpapValue: {
		id: "form.right_heart_catheterization.mpap",
		defaultMessage: "mPAP"
	},
	mpapPostVrt: {
		id: "form.right_heart_catheterization.mpap.post_vrt",
		defaultMessage: "mPAP - postVRT"
	},
	mpcwpValue: {
		id: "form.right_heart_catheterization.mpcwp",
		defaultMessage: "mPCWP"
	},
	mpcwpPostVrt: {
		id: "form.right_heart_catheterization.mpcwp.post_vrt",
		defaultMessage: "mPCWP - postVRT"
	},
	coValue: {
		id: "form.right_heart_catheterization.co",
		defaultMessage: "CO"
	},
	coPostVrt: {
		id: "form.right_heart_catheterization.co.post_vrt",
		defaultMessage: "CO - postVRT"
	},
	ciValue: {
		id: "form.right_heart_catheterization.ci",
		defaultMessage: "CI"
	},
	ciPostVrt: {
		id: "form.right_heart_catheterization.ci.post_vrt",
		defaultMessage: "CI - postVRT"
	},
	tpgValue: {
		id: "form.right_heart_catheterization.tpg",
		defaultMessage: "TPG"
	},
	tpgPostVrt: {
		id: "form.right_heart_catheterization.tpg.post_vrt",
		defaultMessage: "TPG - postVRT"
	},
	pvrValue: {
		id: "form.right_heart_catheterization.pvr",
		defaultMessage: "PVR"
	},
	pvrPostVrt: {
		id: "form.right_heart_catheterization.pvr.post_vrt",
		defaultMessage: "PVR - postVRT"
	}
});

const fields: { [key: string]: FieldData } = {
	vasoreactivityTest: {
		type: "field",
		path: ["vasoreactivityTest"],
		label: messages.vasoreactivityTest,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: vasoreactivityTestMessages }
		}
	},
	rrsValue: {
		type: "field",
		path: ["rrs", "value"],
		label: messages.rrsValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rrsPostVrt: {
		type: "field",
		path: ["rrs", "postVrt"],
		label: messages.rrsPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	hrValue: {
		type: "field",
		path: ["hr", "value"],
		label: messages.hrValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	hrPostVrt: {
		type: "field",
		path: ["hr", "postVrt"],
		label: messages.hrPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	cvpValue: {
		type: "field",
		path: ["cvp", "value"],
		label: messages.cvpValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	cvpPostVrt: {
		type: "field",
		path: ["cvp", "postVrt"],
		label: messages.cvpPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	svO2Value: {
		type: "field",
		path: ["svO2", "value"],
		label: messages.svO2Value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	svO2PostVrt: {
		type: "field",
		path: ["svO2", "postVrt"],
		label: messages.svO2PostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpsValue: {
		type: "field",
		path: ["rvps", "value"],
		label: messages.rvpsValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpsPostVrt: {
		type: "field",
		path: ["rvps", "postVrt"],
		label: messages.rvpsPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpdValue: {
		type: "field",
		path: ["rvpd", "value"],
		label: messages.rvpdValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpdPostVrt: {
		type: "field",
		path: ["rvpd", "postVrt"],
		label: messages.rvpdPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpmValue: {
		type: "field",
		path: ["rvpm", "value"],
		label: messages.rvpmValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	rvpmPostVrt: {
		type: "field",
		path: ["rvpm", "postVrt"],
		label: messages.rvpmPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	papsValue: {
		type: "field",
		path: ["paps", "value"],
		label: messages.papsValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	papsPostVrt: {
		type: "field",
		path: ["paps", "postVrt"],
		label: messages.papsPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	papdValue: {
		type: "field",
		path: ["papd", "value"],
		label: messages.papdValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	papdPostVrt: {
		type: "field",
		path: ["papd", "postVrt"],
		label: messages.papdPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	mpapValue: {
		type: "field",
		path: ["mpap", "value"],
		label: messages.mpapValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	mpapPostVrt: {
		type: "field",
		path: ["mpap", "postVrt"],
		label: messages.mpapPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	mpcwpValue: {
		type: "field",
		path: ["mpcwp", "value"],
		label: messages.mpcwpValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	mpcwpPostVrt: {
		type: "field",
		path: ["mpcwp", "postVrt"],
		label: messages.mpcwpPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	coValue: {
		type: "field",
		path: ["co", "value"],
		label: messages.coValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	coPostVrt: {
		type: "field",
		path: ["co", "postVrt"],
		label: messages.coPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	ciValue: {
		type: "field",
		path: ["ci", "value"],
		label: messages.ciValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	ciPostVrt: {
		type: "field",
		path: ["ci", "postVrt"],
		label: messages.ciPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	tpgValue: {
		type: "field",
		path: ["tpg", "value"],
		label: messages.tpgValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	tpgPostVrt: {
		type: "field",
		path: ["tpg", "postVrt"],
		label: messages.tpgPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	pvrValue: {
		type: "field",
		path: ["pvr", "value"],
		label: messages.pvrValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	pvrPostVrt: {
		type: "field",
		path: ["pvr", "postVrt"],
		label: messages.pvrPostVrt,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.vasoreactivityTest }] },
		{
			columns: [
				{ width: 6, field: fields.rrsValue },
				{ width: 6, field: fields.rrsPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.hrValue },
				{ width: 6, field: fields.hrPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.cvpValue },
				{ width: 6, field: fields.cvpPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.svO2Value },
				{ width: 6, field: fields.svO2PostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.rvpsValue },
				{ width: 6, field: fields.rvpsPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.rvpdValue },
				{ width: 6, field: fields.rvpdPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.rvpmValue },
				{ width: 6, field: fields.rvpmPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.papsValue },
				{ width: 6, field: fields.papsPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.papdValue },
				{ width: 6, field: fields.papdPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.mpapValue },
				{ width: 6, field: fields.mpapPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.mpcwpValue },
				{ width: 6, field: fields.mpcwpPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.coValue },
				{ width: 6, field: fields.coPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.ciValue },
				{ width: 6, field: fields.ciPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.tpgValue },
				{ width: 6, field: fields.tpgPostVrt }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.pvrValue },
				{ width: 6, field: fields.pvrPostVrt }
			]
		}
	]
};

export const node: LeafNode = {
	id: "rightHeartCatheterization",
	value: {
		title: messages.rightHeartCatheterization,
		validator,
		fieldset,
		isImportant: true
	}
};
